import { FC } from 'react';
import { withForm } from 'react-bootstrap-formutil';
import Compliance from 'components/forms/Compliance';
import JobInfo from 'components/forms/JobInfo';
import QuestionnaireEntry from 'components/forms/QuestionnaireEntry';
import { usePowerNavigate } from 'components/PowerNavigate';
import security from 'stores/security';
import values from 'stores/values';
import Container from '../components/Container';

const Job: FC = () => {
    const navigate = usePowerNavigate();
    const handleClickEntry = () => {
        navigate('../qualification-questionnaire');
    };

    return (
        <Container>
            <JobInfo disabled />
            <Compliance disabled />
            <QuestionnaireEntry onClick={handleClickEntry} disabled />
        </Container>
    );
};

export default withForm(Job, {
    $defaultValues: () => {
        values.setShowProgressBar(false);

        return security.customerInfo;
    }
});
